import { jsx as c } from "react/jsx-runtime";
import { useState as u, useEffect as l, useMemo as i } from "react";
import { LocaleContext as m } from "./context3.mjs";
import o from "./en.mjs";
const f = (e) => {
  switch (e) {
    case "es":
      return import("./es.mjs");
    case "zh-Hans":
      return import("./zhHans.mjs");
    case "zh-Hant":
      return import("./zhHant.mjs");
    default:
      return Promise.resolve({ default: o });
  }
}, V = ({ locale: e, children: r }) => {
  const [t, a] = u(o);
  l(() => {
    (async function() {
      const n = await f(e);
      a(n.default);
    })();
  }, [e]);
  const s = i(
    () => ({ locale: e, localeValues: t }),
    [e, t]
  );
  return /* @__PURE__ */ c(m.Provider, { value: s, children: r });
};
export {
  V as LocaleProvider
};
//# sourceMappingURL=LocaleProvider.mjs.map
